import React from "react";

export default function SearchIcon({color}) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="26"
        viewBox="0 0 25 26"
        fill="none"
        style={{transition:'0.3s all'}}
        >
        <path
          style={{transition:'0.3s all'}}
          d="M21.5729 20.5938L18.0313 17.0625C19.1739 15.6067 19.794 13.809 19.7917 11.9583C19.7917 10.3102 19.3029 8.699 18.3873 7.32859C17.4716 5.95818 16.1701 4.89007 14.6474 4.25934C13.1246 3.62861 11.4491 3.46358 9.83259 3.78513C8.21608 4.10667 6.73122 4.90034 5.56578 6.06578C4.40034 7.23122 3.60667 8.71608 3.28513 10.3326C2.96358 11.9491 3.12861 13.6246 3.75934 15.1474C4.39007 16.6701 5.45818 17.9716 6.82859 18.8873C8.199 19.8029 9.81016 20.2917 11.4583 20.2917C13.309 20.294 15.1067 19.6739 16.5625 18.5313L20.0938 22.0729C20.1906 22.1706 20.3058 22.2481 20.4327 22.3009C20.5597 22.3538 20.6958 22.381 20.8333 22.381C20.9709 22.381 21.107 22.3538 21.2339 22.3009C21.3609 22.2481 21.4761 22.1706 21.5729 22.0729C21.6706 21.9761 21.7481 21.8609 21.8009 21.7339C21.8538 21.607 21.881 21.4709 21.881 21.3333C21.881 21.1958 21.8538 21.0597 21.8009 20.9327C21.7481 20.8058 21.6706 20.6906 21.5729 20.5938ZM5.20834 11.9583C5.20834 10.7222 5.57489 9.51383 6.26165 8.48602C6.94841 7.45822 7.92453 6.65714 9.06657 6.18409C10.2086 5.71104 11.4653 5.58727 12.6777 5.82843C13.89 6.06959 15.0037 6.66484 15.8778 7.53892C16.7518 8.413 17.3471 9.52664 17.5882 10.739C17.8294 11.9514 17.7056 13.2081 17.2326 14.3501C16.7595 15.4921 15.9585 16.4683 14.9307 17.155C13.9028 17.8418 12.6945 18.2083 11.4583 18.2083C9.80073 18.2083 8.21102 17.5499 7.03892 16.3778C5.86682 15.2057 5.20834 13.6159 5.20834 11.9583Z"
          fill={color || "#787878"}
        />
      </svg>
    </>
  );
}
